export type LogosGridProps = {
  name: string
  image: string
}

export const logosGridData3: LogosGridProps[] = [
  { name: 'perplexity', image: `perplexity.svg` },
  { name: 'condé nast', image: `conde-nast.svg` },
  { name: 'buzzfeed', image: `buzzfeed.svg` },
  { name: 'mercury', image: `mercury-logo.svg` },
  { name: 'bamboo HR', image: `bambooHR.svg` },
  { name: 'dbt labs', image: `dbt-labs.svg` },
  { name: 'guitar center', image: `guitar-center.svg` },
  { name: 'cribl', image: `cribl.svg` },
]
